/* ai-tabs-sources.tsx generated by @compiled/babel-plugin v0.38.1 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import "./ai-tabs-sources.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { Suspense, useCallback } from 'react';
import { AnalyticsContext } from '@atlaskit/analytics-next';
import { cx } from '@atlaskit/css';
import { SmartCardProvider } from '@atlaskit/link-provider';
import { Box, Inline } from '@atlaskit/primitives/compiled';
import { useAIAnswerContext } from '../../../ai-answer-dialog/ai-answer-context';
import { getSmartLinksAnalyticsContextData, onAIAnswerSourceClick, SmartLinksAnalyticsContextLocation } from '../../../ai-answer-dialog/analytics';
import { SainAction, useSAINUsageCriteriaMet } from '../../../common/controller/analytics';
import { SourceCard, SourceFlexibleSmartCard } from '../../../common/ui/ai-sources/source-card';
import { getSAINLayerFrontendMutiArmExperiment } from '../../../common/utils/get-sain-layer-frontend-experiment';
var styles = {
  sources_container_2_cols: "_yxz3cs5v _gy1ppxbi"
};
var unboundStyles = {
  sources_container_2_cols: "_1cenpxbi"
};
export function AITabsSources() {
  var _useSAINUsageCriteria = useSAINUsageCriteriaMet(),
    fireSAINUsageEvent = _useSAINUsageCriteria.fireSAINUsageEvent;
  var _useAIAnswerContext = useAIAnswerContext(),
    callbacks = _useAIAnswerContext.callbacks,
    commonAttributes = _useAIAnswerContext.commonAttributes,
    fireAnalyticsEvent = _useAIAnswerContext.fireAnalyticsEvent;
  var searchSessionId = commonAttributes.searchSessionId,
    sources = commonAttributes.sources;
  var _getSAINLayerFrontend = getSAINLayerFrontendMutiArmExperiment({
      abTestId: 'kd_sain_sources_redesign_pt_2'
    }),
    cohortSourcesRedesignExperimentPt2 = _getSAINLayerFrontend.cohort;
  var sourceClickCallback = useCallback(function (index, source, hostname) {
    var _callbacks$onAIAnswer;
    fireAnalyticsEvent(onAIAnswerSourceClick(_objectSpread({
      sourceIndex: index,
      hostname: hostname,
      sourceProduct: source.product || ''
    }, commonAttributes)));
    fireSAINUsageEvent({
      metCriteria: SainAction.SOURCE_CLICKED,
      commonAttributes: commonAttributes,
      sourceProduct: source.product || ''
    });
    callbacks === null || callbacks === void 0 || (_callbacks$onAIAnswer = callbacks.onAIAnswerSourceClick) === null || _callbacks$onAIAnswer === void 0 || _callbacks$onAIAnswer.call(callbacks);
  }, [fireAnalyticsEvent, commonAttributes, callbacks, fireSAINUsageEvent]);
  return /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement(React.Fragment, null)
  }, /*#__PURE__*/React.createElement(AnalyticsContext, {
    data: getSmartLinksAnalyticsContextData({
      location: SmartLinksAnalyticsContextLocation.SAIN_Q_AND_A_CARD,
      commonAttributes: commonAttributes
    })
  }, /*#__PURE__*/React.createElement(SmartCardProvider, null, cohortSourcesRedesignExperimentPt2 === 'sources_tab_redesign' ? /*#__PURE__*/React.createElement(Box, {
    xcss: cx(sources.length > 1 && styles.sources_container_2_cols, sources.length > 1 && unboundStyles.sources_container_2_cols)
  }, sources.map(function (source, index) {
    return /*#__PURE__*/React.createElement(SourceFlexibleSmartCard, {
      index: index,
      key: "search-ai-answer-source-".concat(index),
      source: source,
      searchSessionId: searchSessionId,
      onClickHandler: sourceClickCallback
    });
  })) : /*#__PURE__*/React.createElement(Inline, {
    alignBlock: "center",
    rowSpace: "space.100",
    shouldWrap: true,
    space: "space.050"
  }, sources.map(function (source, index) {
    return /*#__PURE__*/React.createElement(SourceCard, {
      index: index,
      key: "search-ai-answer-source-".concat(index),
      source: source,
      searchSessionId: searchSessionId,
      onClickHandler: sourceClickCallback,
      enableSmartLinkSources: true
    });
  })))));
}